import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const getAllFaq = (id) => {
  return Api(`${endPoints.fetchFaq}/${id}`, requestType.POST);
};
const createFaq = (payload) => {
  return Api(endPoints.createFaq, payload, requestType.POST);
};
const updateFaq = (payload, id) => {
  return Api(`${endPoints.updateFaq}/${id}`, payload, requestType.POST);
};
const deleteFaq = (id) => {
  return Api(`${endPoints.deleteFaq}/${id}`, {}, requestType.DELETE);
};
export { getAllFaq, createFaq, updateFaq, deleteFaq };
